import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The optimized `}<strong parentName="p">{`app`}</strong>{` runs in the browser with all the speed of Gatsby as well as the convenience and great developer experience of working with tools like React and GraphQL.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      